// Core
import { ComponentType, lazy, LazyExoticComponent } from 'react';

export type TPreloadable = { preload?: () => Promise<unknown> };

export type TLazyWithPreload<T extends ComponentType<any>> = LazyExoticComponent<T> & {
  preload: () => Promise<unknown>;
};

/**
 * `lazy` that can also be started early: `preload()` runs the same import, so the chunk is already
 * downloaded when React asks for it. The module system dedupes the two calls.
 */
const lazyWithPreload = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
): TLazyWithPreload<T> => {
  const Component = lazy(factory) as TLazyWithPreload<T>;
  Component.preload = factory;

  return Component;
};

export default lazyWithPreload;
